import visiorLogo from "../assets/visiorgames_Logo.png";

const Clients = () => {
  return (
    <div className='clients'>
        <h1  style={{letterSpacing:"2px"}} className='fadeOnScroll' data-translate="ourClients">OUR CLIENTS</h1><br/><br/><br/>
        <div className='clientsContainer fadeOnScroll'>
            <a href="https://www.visiorgames.com">
                <img src={visiorLogo} alt="visior games logo"/>
            </a>
            
        </div>
    </div>
  )
}

export default Clients